export default function Contact() {
  return (
    <section id="contact" className="section section--contact">
      <div className="container">
        <div className="contact-grid">
          <div className="contact-grid__info">
            <span className="section__eyebrow section__eyebrow--light">Get in touch</span>
            <h2 className="section__title section__title--light">
              Have a platform, pipeline, or AI project to build?
            </h2>
            <p className="contact-grid__lead">
              Tell us a bit about what you&rsquo;re working on. We reply within one
              business day with a clear next step - not a sales pitch.
            </p>

            <ul className="contact-grid__list">
              <li>
                <span className="mdi mdi-email-outline" />
                <div>
                  <strong>Email</strong>
                  <a href="mailto:yehuda@dinghy.co.il">yehuda@dinghy.co.il</a>
                </div>
              </li>
              <li>
                <span className="mdi mdi-map-marker-outline" />
                <div>
                  <strong>Location</strong>
                  <span>Israel - remote-friendly worldwide</span>
                </div>
              </li>
              <li>
                <span className="mdi mdi-clock-outline" />
                <div>
                  <strong>Working hours</strong>
                  <span>Sun&ndash;Thu, 09:00&ndash;19:00 IST &middot; 24/7 on-call available</span>
                </div>
              </li>
              <li>
                <span className="mdi mdi-shield-check-outline" />
                <div>
                  <strong>Response</strong>
                  <span>Within 1 business day, guaranteed</span>
                </div>
              </li>
            </ul>
          </div>

          <form
            className="contact-form"
            action="https://formsubmit.co/yehuda@dinghy.co.il"
            method="POST"
          >
            <input type="hidden" name="_subject" value="New lead from dinghy.co.il" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_captcha" value="false" />

            <h3 className="contact-form__title">Start a conversation</h3>

            <div className="contact-form__row">
              <label>
                <span>Name</span>
                <input type="text" name="name" required placeholder="Your full name" />
              </label>
              <label>
                <span>Email</span>
                <input type="email" name="email" required placeholder="you@company.com" />
              </label>
            </div>

            <div className="contact-form__row">
              <label>
                <span>Company</span>
                <input type="text" name="company" placeholder="Company name" />
              </label>
              <label>
                <span>Service of interest</span>
                <select name="service" defaultValue="">
                  <option value="" disabled>Choose a service</option>
                  <option>DevOps Engineering</option>
                  <option>CI/CD Pipelines</option>
                  <option>Cloud Architecture</option>
                  <option>Kubernetes & Microservices</option>
                  <option>Monitoring & Observability</option>
                  <option>Infrastructure as Code</option>
                  <option>FinOps</option>
                  <option>AI & Agent Systems</option>
                  <option>DevSecOps</option>
                  <option>Other</option>
                </select>
              </label>
            </div>

            <label>
              <span>How can we help?</span>
              <textarea
                name="message"
                rows="5"
                required
                placeholder="A few sentences about your project, stack, or biggest pain point."
              />
            </label>

            <button type="submit" className="contact-form__submit">
              Send message <span className="mdi mdi-send" />
            </button>
            <p className="contact-form__note">
              We&rsquo;ll never share your details. By submitting you agree to be
              contacted about your inquiry.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
}
